<template>
  <div class="select-calendar-view-type" v-if="activities.selected"></div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapState(["ui", "activities"]),
  },
  methods: {
    ...mapActions(["calendarViewType"]),
  },
};
</script>
